import {Component, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {TableComponent} from '../ui/table/table.component';
import {BaseComponent} from "../base/base.component";
import {ShopService} from 'src/app/services/shop/shop.service';
import {Product} from "../../models/shop/product";
import {NgxSmartModalService} from "ngx-smart-modal";
import Swal from "sweetalert2";
import { Router } from '@angular/router';
import {ProductSize} from "../../models/shop/ProductSize";

@Component({
  selector: 'app-companies-shop',
  templateUrl: './companies-shop.component.html',
  styleUrls: ['./companies-shop.component.scss']
})
export class CompaniesShopComponent extends BaseComponent implements OnInit {
    @ViewChild('productList') shopList: TableComponent | undefined;
    @Input('deleteEvent') removedImg: any;

    companyId: string = localStorage.getItem('wisper_companyId') ?? '';
    companies: any;
    shop: Product[] = [];

    usersDropdownSettings: any = {}
    constructor(public serviceInjector: Injector,
                public shopService: ShopService,
                private router: Router) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.usersDropdownSettings = {
            idField: 'id',
            textField: "name",
            allowSearchFilter: true,
        };
    }

    async ngAfterViewInit() {
        this.showSpinner();
        this.shopList?.loadData(`/products`, {companyId: this.companyId}, ((item: any) => new Product(item)))
        this.hideSpinner();
    }

    convertToString(item: ProductSize[]) {
        if (!item || item.length < 0) return '';
        return item.map(obj => obj.name).join(', ');
    }


    deleteProduct = async (productId: string) => {
        const success = await this.shopService.deleteProduct(productId)
        if (success) {
            Swal.fire({
                icon: 'success',
                title: 'Prodotto eliminato con successo!',
            });
            this.shopList?.reloadPage();
        } else {
            Swal.fire({
                icon: 'error',
                title: "Errore nell'eliminazione del prodotto",
            })
        }
    }

    navigateToEditPage(productId: string, pageType?: string){
        const params: {} = {
            productToEdit: productId,
            pageType: pageType
        }
        this.router.navigate(['companies/shop/edit'], {queryParams: params})
    }

}
